<template>
   <div class="kj-actions">
    <div class="kj-actions-btns" v-if="selectIndex === 1">
      <button @click="handleBargainForMyselfClick('_bargainFormyself', campaignInf.id)">参与活动,为自己砍价</button>
    </div>
    <div class="kj-actions-btns" v-else-if="selectIndex === 2">
      <button @click="handleAskHelpClick">请朋友帮砍</button>
      <button @click="showSelectButton">立即购买</button>
    </div>
    <div class="kj-actions-btns" v-else-if="selectIndex === 3">
      <button @click="handleAskHelpClick" v-if="isHelpFriendsShow">帮他拉人</button>
      <button @click="handleBargainForOtherClick('_bargainForMyFriends', currentPlay.id)" v-else>帮 TA 砍价</button>
      <button @click="handleJoinYourselfClick">我也要参与</button>
    </div>
    <div class="kj-actions-btns" v-else-if="selectIndex === 4">
      <button @click="handleAskHelpClick">帮他拉人</button>
      <button @click="handleJoinYourselfClick">我也要参与</button>
    </div>
    <yd-popup v-model="isShowPublicInf" position="center" width="auto">
      <div class="kj-actions-tips">
        <button class="kj-actions-close" @click="isShowPublicInf=false"><img src="./close.svg"></button>
        <img :src="`//${publicInf.qrcode_url}`" v-if="publicInf.qrcode_url">
        <p>或搜索公众号: {{publicInf.nick_name}}</p>
        <p class="kj-actions-tips_big">回复关键字 <b>{{campaignInf.wechat_keyword}}</b> 参与活动</p>
      </div>
    </yd-popup>
    <yd-popup v-model="contentShow" position="bottom" height="auto">
      <div class="kj-actions-info">
        <button class="kj-actions-close" @click="contentShow=false"><img src="./close.svg"></button>
        <h2 class="kj-actions-info_head">活动说明</h2>
        <div class="kj-actions-info_box">
          <div class="kj-actions-info_item">
            <div class="kj-actions-info_label">方法1:</div>
            <div class="kj-actions-info_cont">
              <p>长按下图保存发给朋友们</p>
              <div class="kj-actions-info_imgs">
                <div class="kj-actions-info_share_img-wrap">
                  <img v-if="base64Img" class="kj-actions-info_share_img" :style="{opacity: base64Img ? 1 : 0}" crossorigin="anonymous" id='kj-canvas-img' :src="base64Img" />
                </div>
                <canvas id='kj-canvas' width="540" height="815" style="display: none;"></canvas>
                <img class="kj-actions-info_arrow" src="./arrow.png">
              </div>
            </div>
          </div>
          <div class="kj-actions-info_item">
            <div class="kj-actions-info_label">方法2:</div>
            <div class="kj-actions-info_cont">
              <p>复制以下链接发给朋友们</p>
              <div class="kj-actions-info_copy">我非常想要这个宝贝，大家快来帮我砍个价，能省一点是一点，猛戳链接：{{this.shortUrl}}</div>
            </div>
          </div>
        </div>
      </div>
    </yd-popup>
    <TkSkuPopup
      type="cart"
      v-model="onOpt"
      :product-id="item.product_id"
      :sku="item.variant_id"
      :quantity="item.quantity"
      :amountAfter = "currentPlay && currentPlay.amount_after"
      @change = "handleSelectCommodity" />
  </div>
</template>
<script>
import {command} from 'common/js/command.js'
import {getPlayer} from 'common/util/getPlayer'
import {getActivityInfById} from 'api/getActivityInfById'
import {checkIsAttentionWx} from 'api/checkIsAttentionWx'
import {getCommodityInf} from 'api/getCommodityInf'
import {getPublicInf} from 'api/getPublicInf'

import TkSkuPopup from 'base/Sku/Popup'

export default {
  //  暂时不做type检查
  props: [
    'item', 'currentPlay', 'campaignInf',
    'selectIndex', 'shortUrl', 'isBargainForYourself',
    'isBargainedForYourself','isBargainedForHimself', 'qrcode',
    'hasOrder', 'imgSrc', 'lowestPrice', 'originPrice', 'title',
    'stock'],
  data () {
    return {
      contentShow: false,
      index : 0,
      base64Img: '',
      isShowPublicInf: false,
      publicInf: {},
      isHelpFriendsShow: false,
      SKUShow: true,
      onOpt: false
    }
  },
  methods: {
    async isAttentionWx () {
      this.$dialog.loading.open('加载中...')

      const isOk = await checkIsAttentionWx()

      this.$dialog.loading.close()

      return isOk
    },
    canvasImg () {
      var self = this
      const MAX_TEXT_LENGTH = 22
      var backgroundConfig = {
        uri: 'http://kanjia.nos-eastchina1.126.net/540.png?' + Math.random(),
        backgroundColor: '#fff',
        width: 540,
        height: 815
      }
      let qrcode = this.qrcode // base64 no need for random b
      let imgSrc = this.campaignInf.product_image_url + '?' + Math.random()
      let title = this.title
      let lowestPrice = this.lowestPrice
      let originPrice = this.originPrice
      // window.alert(JSON.stringify({qrcode: (),imgSrc,title,lowestPrice,originPrice}))
      var elements = [
        {
          type: 'text',
          text: title,
          font: '22px "PingFang SC", "Microsoft Yahei Light",Lantinghei,"Microsoft Yahei",verdana,sans-serif', // 字体不会设。。。
          color: '#ffffff',
          centerX: 270,
          centerY: 450
        },
        {
          type: 'text',
          text: '只需￥' + lowestPrice,
          font: '44px "PingFang SC", "Microsoft Yahei Light",Lantinghei,"Microsoft Yahei",verdana,sans-serif', // 字体不会设。。。
          color: '#ffef00',
          centerX: 270,
          centerY: 508
        },
        {
          type: 'text',
          text: '原价￥' + originPrice,
          font: '22px "PingFang SC", "Microsoft Yahei Light",Lantinghei,"Microsoft Yahei",verdana,sans-serif', // 字体不会设。。。
          color: '#7287fc',
          centerX: 270,
          centerY: 540
        },
        {
          type: 'image',
          //二维码
          uri: qrcode,
          x0: 372,
          y0: 635,
          x1: 135,
          y1: 135
        },
        {
          type: 'image',
          //商品图片
          uri: imgSrc,
          x0: 128,
          y0: 104,
          x1: 286,
          y1: 286,
          radius: 14 // 有radius的放在最后，不知道有什么后果，别管我
        },
        // http://kanjia.nos-eastchina1.126.net/kjqr.png

      ]

      // remove the lowest text
      if (!parseInt(this.campaignInf.can_show_lowest_price)) elements.splice(1,1)

      function getImage(imageBase64Uri, width, height) {
        return new Promise(function(resolve, reject) {
          var image = new Image(width, height)
          image.crossOrigin = "anonymous"
          image.onload = function() {
            // window.alert('ok ' + imageBase64Uri)
            resolve(image)
          }
          image.onerror = function() {
            reject('error ' + imageBase64Uri)
          }
          image.src = imageBase64Uri
        })
      }
      async function getImageUri(backgroundConfig, elements) {
        var canvas = document.getElementById('kj-canvas')
        // var canvas = document.createElement('canvas')
        var ctx = canvas.getContext('2d')
        // 单个背景
        ctx.fillStyle = backgroundConfig.backgroundColor
        ctx.fillRect(backgroundConfig.x0, backgroundConfig.y0, backgroundConfig.x1, backgroundConfig.y1)

        if (backgroundConfig.uri) {
          var backageImage = await getImage(backgroundConfig.uri, backgroundConfig.width, backgroundConfig.height)
          ctx.drawImage(backageImage, 0, 0)
        }
        //元素
        for (var i = 0; i < elements.length; i++) {
          var element = elements[i]
          switch (element.type) {
            case 'image':
              var image = await getImage(element.uri, element.x1 - element.x0, element.y1 - element.y0)
              if (element.radius) {
                let x = element.x0
                let y = element.y0
                let radius = element.radius
                let width = element.x1
                let height = element.y1

                ctx.beginPath()
                ctx.moveTo(x + radius, y)
                ctx.lineTo(x + width - radius, y)
                ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
                ctx.lineTo(x + width, y + height - radius)
                ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
                ctx.lineTo(x + radius, y + height)
                ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
                ctx.lineTo(x, y + radius)
                ctx.quadraticCurveTo(x, y, x + radius, y)
                ctx.closePath()
                ctx.clip()
              }
              ctx.drawImage(image, element.x0, element.y0, element.x1, element.y1)
              break
            case 'text':
              ctx.font = element.font
              ctx.fillStyle = element.color
              ctx.textAlign = 'center'
              let text = element.text
              if (text.length > MAX_TEXT_LENGTH) {
                text = text.slice(0, MAX_TEXT_LENGTH) + '...'
              }
              //          ctx.setStrikeThruText(true)
              ctx.fillText(text, element.centerX, element.centerY)
              break
            default:
              break
          }
        }

        // if (window.$tk.env.isIOS) {
          self.base64Img = canvas.toDataURL()
        // } else {
        //   canvas.toBlob((blob) => {
        //     self.base64Img = URL.createObjectURL(blob)
        //   })
        // }
        return
      } //海报

      (async ()=> {
        let base64Img = await getImageUri(backgroundConfig, elements)
      })()
      // .catch(window.alert)
    },
    async showSelectButton () {
      this.onOpt = true
    },
    handleSelectCommodity (skuId) {
      this.handleBuyNow('_buyNow', skuId)
    },
    handleAskHelpClick () {
      if (!this.stock) {
        this.$dialog.confirm({
          title: ' ',
          mes: '库存为0，该商品已被抢光！',
          opts: [
            {
              txt: '随便逛逛',
              color: true,
              callback: () => {
              const url = window.location.host + window.location.pathname
              window.location.href = '//' + url
              }
            }
          ]
        })
        return
      }
      if (this.hasOrder) {
        this.$dialog.alert({mes: `砍价任务已完成，不能再继续操作！`})
        return
      }
      this.contentShow = true
      this.canvasImg()
    },
    async handleBargainForMyselfClick (commandStr, id) {
      if (this.campaignInf.need_subscribe_to_play) {
        const isOk = await this.isAttentionWx()
        if (!isOk) {
          this.isShowPublicInf = true
          return
        }
      }

      if (!this.stock) {
        this.$dialog.confirm({
          title: ' ',
          mes: '库存为0，该商品已被抢光！',
          opts: [
            {
              txt: '随便逛逛',
              color: true,
              callback: () => {
              const url = window.location.host + window.location.pathname
              window.location.href = '//' + url
              }
            }
          ]
        })
        return
      }

      command[commandStr](id).then((data) => {
        let bargainPrice = (data / 100).toFixed(2)
        let name = `自己`
        this.$emit('bargainForMysel', {
          handle: this.campaignInf.handle,
          campaignId: this.campaignInf.id,
          price: bargainPrice,
          nickName: name
        })
      }).catch((err) => {
        this.$dialog.loading.close()

        this.$dialog.alert({mes: `${err}`})
      })
    },
    handleBargainForOtherClick (commandStr, id) {
      if (!this.stock) {
        this.$dialog.confirm({
          title: ' ',
          mes: '库存为0，该商品已被抢光！',
          opts: [
            {
              txt: '随便逛逛',
              color: true,
              callback: () => {
              const url = window.location.host + window.location.pathname
              window.location.href = '//' + url
              }
            }
          ]
        })
        return
      }
      if (this.campaignInf.same_person_rule === 'not_allow_same_person' && this.campaignInf.is_helped_campaign) {
        this.$dialog.confirm({
          title: ' ',
          mes: '您已经参加过活动了，不能帮他砍价哦！',
          opts: [
            {
              txt: '取消',
              color: true
            },
            {
              txt: '确定',
              color: true,
              callback: () => {
                this.isHelpFriendsShow = true
              }
            }
          ]
        })
        return
      }
      command[commandStr](id).then((data) => {
        let bargainPrice = (data / 100).toFixed(2)
        let name = encodeURIComponent(this.currentPlay.nick_name)
        this.$emit('bargainForMysel', {
          handle: this.campaignInf.handle,
          campaignId: this.campaignInf.id,
          price: bargainPrice,
          nickName: name
        })
      }).catch((err) => {
        this.$dialog.alert({mes: `${err}`})
      })
    },
    handleJoinYourselfClick () {
      if (!this.stock) {
        this.$dialog.confirm({
          title: ' ',
          mes: '库存为0，该商品已被抢光！',
          opts: [
            {
              txt: '随便逛逛',
              color: true,
              callback: () => {
              const url = window.location.host + window.location.pathname
              window.location.href = '//' + url
              }
            }
          ]
        })
        return
      }
      //  获取handleId
      let href = window.location.href
      let regx = ''
      let handleId = ''
      if (href.indexOf('?') !== -1) {
        regx = /\/products\/.+|\/products\/.+?/
        handleId = href.match(regx).join('').split('/')[2].split('?')[0]
      } else {
        regx = /\/products\/.+|\/products\/.+?/
        handleId = href.match(regx).join('').split('/')[2].split('#')[0]
      }
      //  获取生成的search参数字符串
      let searchArray = window.location.search.split('&')
      searchArray.pop(1)
      let search = searchArray.join('&')
      window.location.href = `/products/${handleId}/${search}`
    },
    handleBuyNow (commandStr, skuId) {
      if (typeof this.isRightAmountAfterPriceTOBuy() === 'string') {
        const msg = this.isRightAmountAfterPriceTOBuy()
        this.$dialog.alert({mes: msg})
        return
      }
      if (!this.stock) {
        this.$dialog.confirm({
          title: ' ',
          mes: '库存为0，该商品已被抢光！',
          opts: [
            {
              txt: '随便逛逛',
              color: true,
              callback: () => {
              const url = window.location.host + window.location.pathname
              window.location.href = '//' + url
              }
            }
          ]
        })
        return
      }
      if (this.hasOrder) {
        this.$dialog.confirm({
          title: ' ',
          mes: '您已提交订单，请先支付或者取消订单才可再次购买！',
          opts: [
            {
              txt: '确定',
              color: true,
              callback: () => {
                const orderNo = this.currentPlay.order_no
                window.location.href = `/account/orders/${orderNo}`
              }
            }
          ]
        })
        return
      }
      let bargainAmount = ''
      let campaignId = this.campaignInf.id
      //  http请求
      this.$dialog.loading.open('加载中...')
      setTimeout(() => {
          this.$dialog.loading.close()
          this.$dialog.alert({mes: '服务器有点慢，请重新购买！'})
      }, 5000)
      getActivityInfById(campaignId).then((activityInf) => {
        bargainAmount = activityInf.play.amount_after
        // 获取handleId
        let href = window.location.href
        let regx = ''
        let handleId = ''
        if (href.indexOf('?') !== -1) {
          regx = /\/products\/.+|\/products\/.+?/
          handleId = href.match(regx).join('').split('/')[2].split('?')[0]
        } else {
          regx = /\/products\/.+|\/products\/.+?/
          handleId = href.match(regx).join('').split('/')[2].split('#')[0]
        }
        //  立即购买并跳转到下单页
        localStorage.clear()
        command[commandStr](handleId, bargainAmount, campaignId, skuId)
      })
    },
    isRightAmountAfterPriceTOBuy () {
      const lowest_price = this.campaignInf.lowest_price - 0
      const purchase_mode = this.campaignInf.purchase_mode
      const amount_after = this.currentPlay.amount_after - 0
      const highest_price_to_order = this.campaignInf.highest_price_to_order - 0
      if (purchase_mode === 'specific' && amount_after > highest_price_to_order) {
        return `低至 ${(highest_price_to_order / 100 + 1e-6).toFixed(2)} 元才可购买！`
      }
      if (purchase_mode === 'any') {
        return true
      }
      if (purchase_mode === 'full' && amount_after > lowest_price) {
        return `低至 ${(lowest_price/ 100 + 1e-6).toFixed(2)} 元才可购买！`
      }
    }
  },
  async created () {
    try{
      this.publicInf = await getPublicInf()
    } catch (err) {
      console.log(err)
    }
  },
  components: {
    TkSkuPopup
  }
}
</script>
<style scoped>

.kj-actions-btns {
  display: flex;
  margin: 10px 5px;
}
.kj-actions-btns button {
  flex: 1;
  margin: 0 5px;
  padding: 14px 0;
  border: none;
  border-radius: 5px;
  background: linear-gradient(#ffc140, #ff9e36);
  color: #fff;
  font-size: 18px;
  line-height: 1;
}
.kj-actions-btns button:first-child {
  background: linear-gradient(#ff8227, #ff5400);
}

.kj-actions-close {
  box-sizing: content-box;
  display: block;
  margin: 0;
  padding: 15px;
  background: transparent;
  border: none;
  font-size: 0;
  line-height: 1;
  height: auto;
  width: auto;
  color: #333
}
.kj-actions-close img {
  display: block;
  max-width: 15px;
  max-height: 15px;
}

.kj-actions-tips {
  position: relative;
  padding: 20px 15px;
  width: auto;
  max-width: 100%;
  border-radius: 5px;
  background-color: #fff;
  text-align: center;
  overflow: hidden;
}
.kj-actions-tips .kj-actions-close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 11px;
}
.kj-actions-tips img {
  display: block;
  margin: 0 auto;
  width: 230px;
}
.kj-actions-tips p {
  margin: 0 0 10px;
  padding: 0;
  line-height: 1;
}
.kj-actions-tips_big {
  font-size: 16px;
}

.kj-actions-info {
  position: relative;
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: 100vh;
  overflow: hidden;
  line-height: 1;
}
.kj-actions-info_head {
  display: flex;
  margin: 0;
  padding: 16px 15px;
  border: 0 solid #dddddd;
  border-width: 0 0 .5px;
  line-height: 1;
  font-size: 20px;
}
.kj-actions-close {
  position: absolute;
  top: 3px;
  right: 0;
}
.kj-actions-info_box {
  padding: 20px 0;
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
  overflow-scrolling: touch;
}
.kj-actions-info_item {
  display: flex;
  margin: 0 0 20px;
  padding: 0 15px;
}
.kj-actions-info_label {
  margin: 0 8px 0 0;
  color: #ff5555;
  font-weight: bold;
  line-height: 1;
}
.kj-actions-info_cont {
  flex: 1;
  font-weight: bold;
}
.kj-actions-info_cont p {
  line-height: 1;
  margin: 0 0 12px;
}
.kj-actions-info_imgs {
  display: flex;
  margin: 0;
}
.kj-actions-info_share_img-wrap {
  width: 130px;
  height: 196px;
}
.kj-actions-info_share_img {
  display: block;
  width: 130px;
  height: 196px;
  max-width: 100%;
  max-height: 100%;
  border: 1px solid #8b8b8b;
  opacity: 0;
}
.kj-actions-info_arrow {
  display: block;
  margin: auto auto auto 15px;
  width: 35px;
}
.kj-actions-info_copy {
  padding: 7px 8px;
  font-weight: normal;
  border: .5px solid #ccc;
  border-radius: 3px;
  line-height: 18px;
  white-space: normal;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// index.vue?536fa11e